module.exports = __webpack_public_path__ + "img/mouse_left.fef7cb73.svg";